import Initializer, {
  CONFIGS_KEY,
  BOOTSTRAP_DATA_KEY,
} from '@qwerty.software/store-manager/lib/initializer'

init()

export const initializing = new Promise(resolve => {
  Initializer.getInstance().addEventListener('init', onInit)

  function onInit() {
    Initializer.getInstance().removeEventListener('init', onInit)

    resolve(true)
  }
})

async function init() {
  const StoreManager = await import('@qwerty.software/store-manager/lib')
    .then(_module => _module.default.default)

  return Initializer.init(StoreManager, window[CONFIGS_KEY], window[BOOTSTRAP_DATA_KEY])
}
